import { Component, OnInit } from '@angular/core';
import { ErrorService } from './services/error.service';
import { Router, NavigationEnd } from '@angular/router';
import { AuthService } from './services/auth/auth.service';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {

  hideHeaderFooter: boolean;
  public error$ = this.errorService.error$;

  constructor(private router: Router, private errorService: ErrorService, public authService: AuthService) {
  }

  ngOnInit(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.hideHeaderFooter = this.isAccessDeniedPage();
      });
  }
 
  private isAccessDeniedPage(): boolean {
    // Check if the current route's URL contains 'access-denied'
    return this.router.url.includes('access-denied');
  }

}
